import React from 'react'

export default function WhatsAppButton () {
  const whatsappUrl =
    'https://wa.me/918956627942?text=Hi%2C%20I%20would%20like%20to%20inquire%20about%20your%20logistics%20services'

  return (
    <>
      <style>{`
        @keyframes whatsappPulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.45);
          }
          70% {
            box-shadow: 0 0 0 13px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }

        .whatsapp-pulse {
          animation: whatsappPulse 2.2s infinite;
        }

        @media (prefers-reduced-motion: reduce) {
          .whatsapp-pulse {
            animation: none !important;
          }
        }
      `}</style>

      <a
        href={whatsappUrl}
        target='_blank'
        rel='noopener noreferrer'
        aria-label='Connect with S Infinite Express on WhatsApp'
        title='Chat with us on WhatsApp'
        className='fixed bottom-[25px] right-4 sm:bottom-10 sm:right-7 z-[9997] group'
      >
        {/* Tooltip */}
        <span className='absolute right-[72px] top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#211f57] text-white text-xs font-semibold px-4 py-2 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300'>
          Chat with us on WhatsApp
          <span className='absolute top-1/2 -right-1 -translate-y-1/2 w-2 h-2 bg-[#211f57] rotate-45' />
        </span>

        {/* WhatsApp Button */}
        <div className='relative w-[48px] h-[48px] sm:w-[60px] sm:h-[60px] rounded-full bg-gradient-to-br from-[#2AE878] to-[#16A34A] shadow-[0_8px_25px_rgba(37,211,102,0.35)] flex items-center justify-center whatsapp-pulse group-hover:scale-110 group-hover:shadow-xl transition-all duration-300'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 32 32'
            fill='white'
            className='w-6 h-6 sm:w-8 sm:h-8'
            aria-hidden='true'
          >
            <path d='M16 .5C7.3.5.5 7.3.5 16c0 2.8.7 5.4 2 7.7L.5 31.5 8.8 30c2.2 1.3 4.9 2 7.7 2 8.7 0 15.5-6.8 15.5-15.5S24.7.5 16 .5zm0 28.1c-2.3 0-4.6-.6-6.6-1.8l-.5-.3-4.9 1.1 1-4.7-.3-.5c-1.2-2-1.9-4.3-1.9-6.6 0-7.5 6.1-13.6 13.6-13.6S29.6 8.5 29.6 16 23.5 28.6 16 28.6zm7.7-10.6c-.4-.2-2.3-1.1-2.7-1.2-.4-.2-.7-.2-1 .2s-1.2 1.2-1.5 1.5-.5.2-.9 0c-.4-.2-1.6-.6-3-2-1.1-1.1-1.9-2.5-2.1-2.9-.2-.4 0-.6.2-.8.2-.2.4-.5.6-.7s.2-.4.3-.6.1-.4 0-.6c-.1-.2-1-2.3-1.4-3.2-.4-1-.8-.8-1.1-.8-.3 0-.6 0-.9 0s-.6.1-.8.3c-.2.2-1.1 1.1-1.1 2.8s1.2 3.3 1.4 3.6c.2.3 2.4 3.7 5.8 5.1.8.3 1.4.5 1.9.6.8.2 1.5.1 2 .1.6-.1 1.8-.7 2.1-1.4.3-.7.3-1.3.2-1.4-.1-.1-.4-.3-.8-.4z' />
          </svg>

          {/* Online indicator */}
          {/* <span className='absolute top-0 right-0 w-3.5 h-3.5 bg-white rounded-full flex items-center justify-center'>
            <span className='w-2 h-2 bg-green-500 rounded-full' />
          </span> */}
        </div>
      </a>
    </>
  )
}
